import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import MainHeader from './components/nav/MainHeader';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import BackgroundProvider from './components/BackgroundProvider';
import Award from './pages/Award';
import Donate from './pages/Donate';
import Document from './pages/Document';
import GetInvolved from './pages/GetInvolved';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';

import LoginPage from "./components/LoginPage";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AboutIndex from './components/pagedata/about/AboutIndex';
import AdvisoryCommittee from './components/pagedata/about/AdvisoryCommittee';
import BoardOfDirectors from './components/pagedata/about/BoardOfDirectors';
import History from './components/pagedata/about/History';
import Projects from './components/pagedata/about/Projects';
import Facilities from './components/pagedata/about/Facilities';
import WhatWeDo from './components/pagedata/about/WhatWeDo';

function App() {
  return (
    <BrowserRouter>
      <BackgroundProvider>
        <Routes>
          {/* Main Public Site Routes */}
          <Route path="/" element={<MainHeader />}>
            <Route index element={<Navigate to="home" />} />
            <Route path="home" element={<Home />} />
            <Route path="/about" element={<About />}>
              <Route index element={<AboutIndex />} />
              <Route path="advisory-committee" element={<AdvisoryCommittee />} />
              <Route path="board-of-directors" element={<BoardOfDirectors />} />
              <Route path="history" element={<History />} />
              <Route path="projects" element={<Projects />} />
              <Route path="facilities" element={<Facilities />} />
              <Route path="what-we-do" element={<WhatWeDo />} />
            </Route>
            <Route path="gallery/*" element={<Gallery />} />
            <Route path="award/*" element={<Award />} />
            <Route path="donate" element={<Donate />} />
            <Route path="document" element={<Document />} />
            <Route path="get-involved/*" element={<GetInvolved />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy-terms" element={<Privacy />} />
            <Route path="*" element={<Home />} />
          </Route>

          {/* Admin Portal Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin/*" element={
            <ProtectedRoute><Dashboard /></ProtectedRoute>
          } />
        </Routes>
      </BackgroundProvider>
    </BrowserRouter>
  );
}

export default App;